const searchFormClass = 'c-search-form';
const summaryContentClass = searchFormClass + '__summary-content';
const summaryContentHiddenClass = summaryContentClass + '--hidden';

const searchFormJsClass = 'js-search-form';
const detailsJsClass = searchFormJsClass + '-details';
const summaryJsClass = searchFormJsClass + '-summary';
const summaryContentOpenJsClass = searchFormJsClass + '-summary-open';
const summaryContentCloseJsClass = searchFormJsClass + '-summary-close';

const detailsElement = document.querySelector('.' + detailsJsClass) as HTMLDetailsElement;
const summaryElement = document.querySelector('.' + summaryJsClass) as HTMLElement;
const summaryContentOpenElement = document.querySelector('.' + summaryContentOpenJsClass) as HTMLElement;
const summaryContentCloseElement = document.querySelector('.' + summaryContentCloseJsClass) as HTMLElement;

if (detailsElement && summaryElement && summaryContentOpenElement && summaryContentCloseElement) {
    // We add a click event listener to toggle the details
    summaryElement.addEventListener('click', () => {
        toggleDetails();
    });
}

function toggleDetails (): void {
    // If the details is closed
    if (detailsElement && !detailsElement.open) {
        // Show the close element
        summaryContentCloseElement.classList.remove(summaryContentHiddenClass);
        // hide the open element
        summaryContentOpenElement.classList.add(summaryContentHiddenClass);
    } else if (detailsElement && detailsElement.open) {
        // Hide the close element
        summaryContentCloseElement.classList.add(summaryContentHiddenClass);
        // Show the open element
        summaryContentOpenElement.classList.remove(summaryContentHiddenClass);
    }
}